<template>

  <div class="page">


    <div class="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar app-theme-gray"
         :class="{'closed-sidebar':!menuFixed, 'clicked':menuClicked, 'menu-fixed':menuFixed, 'sidebar-mobile-open': openMenuMobile}">

      <t-app-header v-if="pageIsLoaded" :user="user" @pageRefresh="onPageRefresh()" :fast-insert="fastInsert"/>

      <div class="app-main" v-if="pageIsLoaded">

        <t-app-menu :menu="menu" @pageRefresh="onPageRefresh()"/>

        <transition mode="out-in"
                    enter-active-class="animated fadeIn">
          <router-view ref="routerView" v-if="mounted"/>
        </transition>

      </div>

      <div v-else class="d-flex align-items-center justify-content-center h-100-header">

        <div class="loader-wrapper d-flex justify-content-center align-items-center">
          <div class="loader">
            <div class="ball-pulse-sync">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>

      </div>

    </div>

    <t-app-menu-right/>

    <t-app-blackout/>


  </div>


</template>
<script>
import tAppHeader from "@/components/template/header/t-app-header";
import tAppMenu from "@/components/template/menu/t-app-menu";
import tAppMenuRight from "@/components/template/menu-right/t-app-menu-right";
import tAppBlackout from "@/components/template/theme/t-app-blackout";
import http from "@/services/config/http-common";
import ui from "@/assets/scripts/ui";

export default {
  name: 'Routes',
  components: {tAppHeader, tAppMenu, tAppMenuRight, tAppBlackout},
  data() {
    return {
      menu: [],
      user: {},
      fastInsert: [],
      pageIsLoaded: false,
      mounted: true,
    }
  },
  created() {
    ui.customTemplate()
  },
  async mounted() {


    await http.get("general/assemble").then(async (response) => {

      this.menu = response.data.menu
      this.user = response.data.user
      this.fastInsert = response.data.fastInsert
      const account = this.$store.getters.getAccountUser

      //Seta os grupos do usuário para utilização futura
      this.$store.commit("setGroupUser", this.user.groupUser)

      this.setPreferences(this.user.preferences)


      if (account && account.tempPassword && this.$router.history.current.name !== 'my-user-change-password') {
        await this.$router.push({name: 'my-user-change-password', query: {tempPassword: 'true'}})
      } else if (this.$router.history.current.name === 'default') {
        await this.$router.push({name: 'dashboard'})
      }

      this.pageIsLoaded = true

    }).catch(error => {

      if (error.response && error.response.status === 401) {

        let redirectedFrom

        if (this.$route.name === 'default') {
          //Origem
          redirectedFrom = this.$route.redirectedFrom
        } else {
          //Proprio elemento (geralmente dashboard)
          redirectedFrom = this.$route.fullPath
        }

        //Neste caso será no próprio storage o armazenamento, pois no Vuex poderá perde devido os redirects que são realizados
        localStorage.setItem('redirectedFrom', redirectedFrom)
        ui.logout(this)

      } else {
        ui.msgError(this, "Erro ao tentar montar menu: " + error + ", por favor atualize a página e se o problema persistir informe nosso suporte técnico o erro: " + error + ".")
      }

    })

  },
  methods: {

    async onPageRefresh() {
      /*Atualizar a página*/

      this.mounted = false
      setTimeout(() => this.mounted = true, 200)

    },


    setPreferences(preferences) {

      //Fora do padrão do menu Fixed, deverá setar como não fixo
      if (!preferences.menuFixed) {
        this.$store.commit("setMenuFixed", false)
      }

    },


  },
  computed: {

    menuFixed() {
      return this.$store.getters.getMenuFixed
    },
    menuClicked() {
      return this.$store.getters.getMenuClicked
    },
    openMenuMobile() {
      return this.$store.getters.getOpenMenuMobile
    },

  },


}
</script>
<style>
/*.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}*/
</style>
